<template>
  <b-container fluid style="min-height: calc(100vh - 200px)" class="px-0">
      <b-row>
          <Tables ref="tableGrid"
                  class="col-md-5 mb-3 tabela"
                  :columns="[$lang.PCI.ServiceAnalysisTec.DataTable.Description,
                            $lang.Common.DataTable.ActionDate,
                            $lang.Common.DataTable.Actions]"
                  v-on:Load="onLoad">
            <template #headerCard-actions><i class="fas fa-copy"></i></template>
            <tr v-for="obj in this.objList" v-bind:key="obj.id">
              <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.descricao" />
              <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataAcao" />
              <TableColumn :HasChange="false" :IsActionsButtons="true" v-on:Delete="onDelete(obj)" :status="obj.status" />
            </tr>
          </Tables>

          <forms class="col-md-7 mb-0 pl-0"
                 id="form"
                 :title="$lang.PCI.ServiceAnalysisTec.Title"
                 :showClearButton="true"
                 :showSaveButton="true"
                 v-on:Clear="onClearForm"
                 v-on:Save="onSaveForm">
            <div class="form-group row">
              <div class="col-md-12 mb-3">
                <label for="txtDescricao"><small v-if="form.descricao.required">* </small>{{$lang.PCI.ServiceAnalysisTec.LabelDescription}}:</label>
                <div class="flex-grow-1 pl-1 pr-0 mb-1">
                  <b-form-input type="text"
                              name="txtDescricao"
                              ref="txtDescricao"
                              :placeholder="$lang.PCI.ServiceAnalysisTec.PlaceholderDescription"
                              v-model="form.descricao.value"
                              :required="form.descricao.required"
                              :maxlength="form.descricao.maxlength"
                              :state="form.descricao.state" />
                </div>
              </div>
            </div>
          </forms>
      </b-row>
  </b-container>
</template>

<script>
import ServiceAnalysisTec from './serviceanalysistec.js'
export default ServiceAnalysisTec
</script>

<style scoped>
#actions {
  display: none;
}

div#item:hover > div#actions {
  display: flex;
}

div#customColumn:hover > div#actions {
  display: flex;
}

#form >>> div.card {
  margin-bottom: 0;
}

i {
  font-size: 1rem;
}

i.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/serviceanalysistec/serviceanalysistec.vue